import React from 'react';
import Plot  from 'react-plotly.js';

export default function EnergyProduction() {
  /* ---------- DATA ARRAYS ---------- */
const years = [1950, 1960, 1970, 1980, 1990, 2000, 2010, 2020];

const coal = [
  12.377,  // 1950–1959
  12.261,  // 1960–1969
  14.830,  // 1970–1979
  18.837,  // 1980–1989
  21.949,  // 1990–1999
  22.964,  // 2000–2009
  20.165,  // 2010–2019
  11.788   // 2020–2023
];

const naturalGas = [
  9.748,   // 1950–1959
  14.650,  // 1960–1969
  20.283,  // 1970–1979
  18.313,  // 1980–1989
  18.714,  // 1990–1999
  19.787,  // 2000–2009
  25.211,  // 2010–2019
  36.696   // 2020–2023
];

const crudeOil = [
  13.351,  // 1950–1959
  15.796,  // 1960–1969
  18.333,  // 1970–1979
  18.206,  // 1980–1989
  14.667,  // 1990–1999
  12.203,  // 2000–2009
  17.972,  // 2010–2019
  24.134   // 2020–2023
];

const ngpl = [
  1.028,   // 1950–1959
  1.611,   // 1960–1969
  2.393,   // 1970–1979
  2.195,   // 1980–1989
  2.374,   // 1990–1999
  2.406,   // 2000–2009
  4.389,   // 2010–2019
  7.009    // 2020–2023
];

const nuclear = [
  0.001,   // 1950–1959 (only 1958–1959 have data)
  0.045,   // 1960–1969
  2.013,   // 1970–1979
  3.784,   // 1980–1989
  6.324,   // 1990–1999
  7.864,   // 2000–2009
  8.300,   // 2010–2019
  8.136    // 2020–2023
];

const renewables = [
  1.835,   // 1950–1959
  1.936,   // 1960–1969
  2.567,   // 1970–1979
  3.967,   // 1980–1989
  4.024,   // 1990–1999
  4.181,   // 2000–2009
  6.763,   // 2010–2019
  8.150    // 2020–2023
];
const totals = [
  38.340,  // 1950–1959
  46.299,  // 1960–1969
  60.419,  // 1970–1979
  65.302,  // 1980–1989
  68.052,  // 1990–1999
  69.405,  // 2000–2009
  82.800,  // 2010–2019
  95.913   // 2020–2023
];
function percentOfTotal(series, totals) {
  return series.map((v, i) => v / totals[i]);   // decimal fraction (0‑1)
}

const coalPct       = percentOfTotal(coal, totals);
const gasPct        = percentOfTotal(naturalGas, totals);
const oilPct        = percentOfTotal(crudeOil, totals);
const ngplPct       = percentOfTotal(ngpl, totals);
const nuclearPct    = percentOfTotal(nuclear, totals);
const renewablesPct = percentOfTotal(renewables, totals);

  /* ---------- TRACE DEFINITIONS ---------- */
const hover = [
  'Decade: %{x}s',
  'Energy: %{y:.2f} QBtu',
  'Share: %{customdata:.1%} of total',
  '<extra></extra>'
].join('<br>');

const traces = [
  { x: years, y: coal,       customdata: coalPct,       name: 'Coal',        type: 'bar', marker: { color: '#4C4C4C' }, hovertemplate: hover },
  { x: years, y: naturalGas, customdata: gasPct,        name: 'Natural Gas', type: 'bar', marker: { color: '#03dbfc' }, hovertemplate: hover },
  { x: years, y: crudeOil,   customdata: oilPct,        name: 'Crude Oil',   type: 'bar', marker: { color: '#ff3333' }, hovertemplate: hover },
  { x: years, y: ngpl,       customdata: ngplPct,       name: 'NGPL',        type: 'bar', marker: { color: '#ffa1e7' }, hovertemplate: hover },
  { x: years, y: nuclear,    customdata: nuclearPct,    name: 'Nuclear',     type: 'bar', marker: { color: '#ff9900' }, hovertemplate: hover },
  { x: years, y: renewables, customdata: renewablesPct, name: 'Renewables',  type: 'bar', marker: { color: '#228B22' }, hovertemplate: hover }
];



  /* ---------- PLOT ---------- */
  return (
    <Plot
      data={traces}
      layout={{

        title: 'U.S. Primary Energy Production by Source (Decade Averages)',
        barmode: 'stack',

        xaxis: { title: 'Year', tickangle: -45, tickfont: { size: 8 }, fixedrange: true },
        yaxis: { title: 'Quadrillion Btu', fixedrange: true },
        legend: { orientation: 'h', y: -0.15 },
        margin: { t: 80, l: 60, r: 20, b: 120 },
        autosize: true
      }}

      useResizeHandler={true}
  style={{ width: "100%", height: "100%" }}
  config={{ displayModeBar: false, scrollZoom: false }}
    />
  );
}
